import { useState } from "react";
import Swal from "sweetalert2";

export const useVoucher = () => {
  const [voucherValid, setVoucherValid] = useState(false);

  const validateVoucher = (voucherInput) => {
    const validVoucherCode = "NIECWEF50";

    if (voucherInput?.toUpperCase() === validVoucherCode) {
      setVoucherValid(true);

      Swal.fire({
        icon: "success",
        title: "Voucher Applied!",
        text: "You get a 50% discount!",
      });

      return true;
    }

    setVoucherValid(false);

    Swal.fire({
      icon: "error",
      title: "Invalid Voucher",
      text: "Please enter a valid voucher code.",
    });

    return false;
  };

  return { voucherValid, validateVoucher };
};